import React, { useState, useEffect } from "react";
import "./style/OtpVerify.css";
import meetingPlusLogo from "../../assets/images/MinutesPlusVaultLogo1.svg";
import LoginImage from "./LoginImage";
import Spinner from "react-bootstrap/Spinner";
import { FaInfoCircle } from "react-icons/fa";
import {
  reSendOtp,
  setPassword,
  updateIsSuccess,
  updateOtpProcessed,
} from "../../redux/actions/authActions/authAction";
import { useSelector, useDispatch } from "react-redux";
import * as constantMessages from "../../constants/constatntMessages";
import { useNavigate, Navigate, Link } from "react-router-dom";
import Timer from "../Common/Timer";
import { encryptWithAES } from "../../helpers/commonHelpers";
import { toast } from "react-toastify";

const SetPassword = () => {
  document.body.classList.remove("landing-page");
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();
  const authData = useSelector((state) => state.auth);
  const [formData, setFormData] = useState({
    input1: null,
    input2: null,
    input3: null,
    input4: null,
    input5: null,
    input6: null,
    password: "",
    confirmPassword: "",
  });
  const navigate = useNavigate();
  const isLogIn = false;
  useEffect(() => {
    document.title = "Set Password: MinutesVault";
    const inputId = document.getElementById(parseInt(1));
    inputId.focus();
    if (isLogIn) {
      navigate("/dashboard");
    }
    if (!authData.email) {
      navigate("/login");
    }
    return () => {
      toast.dismiss(); // removes all toasts
    };
  }, []);

  const handleChange = (e) => {
    dispatch(updateOtpProcessed(false));
    const { value, name, id } = e.target;

    // 👉 If it's a password or confirmPassword field, just update normally
    if (name === "password" || name === "confirmPassword") {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
      return;
    }

    // 👉 Otherwise treat it as OTP input
    const digitsOnly = value.replace(/\D/g, ""); // extract only digits
    const updatedFormData = { ...formData };
    let currentIndex = parseInt(id);

    // Fill each digit into corresponding field
    for (
      let i = 0;
      i < digitsOnly.length && currentIndex <= 6;
      i++, currentIndex++
    ) {
      updatedFormData[`input${currentIndex}`] = digitsOnly[i];
      const inputField = document.getElementById(currentIndex);
      if (inputField) inputField.value = digitsOnly[i];
    }

    setFormData(updatedFormData);

    // Move focus to next empty field
    for (let i = parseInt(id) + digitsOnly.length; i <= 6; i++) {
      if (!updatedFormData[`input${i}`]) {
        const nextField = document.getElementById(i);
        if (nextField) {
          nextField.focus();
          break;
        }
      }
    }
  };

  // PRATISHRUTI START CODE HERE

  const handleKeyDown = (e) => {
    const { id, name } = e.target;
    const fieldId = parseInt(id);

    const invalidKeys = ["e", "-", "+", ".", ","];

    if (invalidKeys.includes(e.key.toLowerCase())) {
      e.preventDefault();
      return;
    }

    if (e.key === "Backspace") {
      setFormData((prev) => ({
        ...prev,
        [name]: "",
      }));

      // Delay the focus movement to allow input to clear first
      setTimeout(() => {
        const currentInput = document.getElementById(fieldId);
        if (currentInput?.value === "") {
          const prevField = document.getElementById(fieldId - 1);
          if (prevField) {
            prevField.focus();
          }
        }
      }, 0);
    }
  };
  // PRATISHRUTI END CODE HERE

  const otp = [];
  const validateForm = (data) => {
    dispatch(updateOtpProcessed(false));
    const errors = {};
    if (!authData.email) {
      errors.message = constantMessages.emailRequired;
    }
    if (!data.input1) {
      errors.message = "OTP is required";
    } else if (isNaN(data.input1)) {
      errors.message = "OTP must be a number";
    }

    otp.push(data.input1);

    if (!data.input2) {
      errors.otp = "OTP is required";
    } else if (isNaN(data.input2)) {
      errors.otp = "OTP must be a number";
    }
    otp.push(data.input2);
    if (!data.input3) {
      errors.otp = "OTP is required";
    } else if (isNaN(data.input3)) {
      errors.otp = "OTP must be a number";
    }
    otp.push(data.input3);
    if (!data.input4) {
      errors.otp = "OTP is required";
    } else if (isNaN(data.input4)) {
      errors.otp = "OTP must be a number";
    }
    otp.push(data.input4);
    if (!data.input5) {
      errors.otp = "OTP is required";
    } else if (isNaN(data.input5)) {
      errors.otp = "OTP must be a number";
    }
    otp.push(data.input5);

    if (!data.input6) {
      errors.otp = "OTP is required";
    } else if (isNaN(data.input6)) {
      errors.otp = "OTP must be a number";
    }

    if (!data.input6) {
      errors.otp = "OTP is required";
    } else if (isNaN(data.input6)) {
      errors.otp = "OTP must be a number";
    }

    otp.push(data.input6);
    if (otp.length !== 6) {
      errors.message = "OTP must be of 6 digits";
    }
    const otpData = otp.join("");

    const regularExpression =
      /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;

    if (!data.confirmPassword.trim()) {
      errors.confirmPassword = constantMessages.confirmPasswordRequired;
    } else if (data.password !== data.confirmPassword) {
      errors.confirmPassword = constantMessages.confirmAndMainPasswordMatch;
    }

    if (!data.password.trim()) {
      errors.password = constantMessages.passwordRequired;
    } else if (!regularExpression.test(data.password)) {
      errors.password = constantMessages.wrongPasswordFormat;
    }
    return {
      errors,
      otpData,
    };
  };

  const otpFieldValidationCheck = (e) => {
    const errors = {};

    if (!e.target.value) {
      errors.otp = "OTP is required";
    } else if (isNaN(e.target.value)) {
      errors.otp = "OTP must be a number";
    }

    setErrors(errors);
  };

  const confirmPasswordFieldValidationCheck = (e) => {
    const errors = {};

    if (!formData.confirmPassword.trim()) {
      errors.confirmPassword = constantMessages.confirmPasswordRequired;
    } else if (formData.password !== formData.confirmPassword) {
      errors.confirmPassword = constantMessages.confirmAndMainPasswordMatch;
    }
    setErrors(errors);
  };

  const passwordFieldValidationCheck = (e) => {
    const errors = {};

    const regularExpression =
      /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
    if (!formData.password.trim()) {
      errors.password = constantMessages.passwordRequired;
    } else if (!regularExpression.test(formData.password)) {
      errors.password = constantMessages.wrongPasswordFormat;
    }
    setErrors(errors);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = validateForm(formData);
    setErrors(newErrors?.errors);
    if (Object.keys(newErrors.errors).length === 0) {
      // Form submission logic here
      const otp = newErrors.otpData;
      dispatch(
        setPassword({
          email: authData.email,
          otp,
          password: await encryptWithAES(formData.password),
        })
      );
    } else {
    }
  };

  const resendOtpAction = (e) => {
    if (authData.email) {
      dispatch(reSendOtp(authData.email));
      setFormData({
        ...formData,
        input1: "",
        input2: "",
        input3: "",
        input4: "",
        input5: "",
        input6: "",
      });
    } else {
      errors.message = constantMessages.emailRequired;
      setErrors(errors);
    }
  };
  const showPassword = (id) => {
    var x = document.getElementById(id);
    if (x.type === "password") {
      x.type = "text";
    } else {
      x.type = "password";
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text").trim();
    const digitsOnly = pastedData.replace(/\D/g, "");

    if (!digitsOnly) return;

    const updatedFormData = { ...formData };

    // Find the field where the paste occurred
    const startId = parseInt(e.target.id);
    let currentIndex = startId;

    for (
      let i = 0;
      i < digitsOnly.length && currentIndex <= 6;
      i++, currentIndex++
    ) {
      updatedFormData[`input${currentIndex}`] = digitsOnly[i];

      const inputField = document.getElementById(currentIndex);
      if (inputField) {
        inputField.value = digitsOnly[i];
      }
    }

    setFormData(updatedFormData);

    // Move focus to next empty field
    for (let i = startId + digitsOnly.length; i <= 6; i++) {
      if (!updatedFormData[`input${i}`]) {
        const nextField = document.getElementById(i);
        if (nextField) {
          nextField.focus();
          break;
        }
      }
    }
  };

  return (
    <section className="otp-varify set-pswrd">
      {authData.isOtpVerifiedSuccess && authData.isSuccess ? (
        <Navigate to="/login-by-password" state={formData} />
      ) : null}

      <div className="container-fluid">
        <div className="row login-row">
          <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 first-login-col">
            <div className="loginform-container abstract-bg">
              <div className="logo-container">
                <Link to="/">
                  <img
                    className="login-logo"
                    // @ts-ignore
                    src={meetingPlusLogo}
                    alt="logo"
                  />
                </Link>
              </div>
              <form className="set-password1" onSubmit={handleSubmit}>
                <div className="text">
                  <h4>Welcome to MinutesVault</h4>
                  <p>Set Password</p>
                </div>

                <div className="form-group mb-0">
                  <div className="otp-Check">
                    <label className="mb-1">
                      Enter Your 6 Digit OTP{" "}
                      <span className="imp-field">*</span>
                    </label>
                    <div className="pincode">
                      <div className="digit">
                        <input
                          type="number"
                          name="input1"
                          maxLength={1}
                          onChange={handleChange}
                          onKeyDown={handleKeyDown} // PRATISHRUTI ADD CODE HERE
                          onBlur={otpFieldValidationCheck}
                          value={formData.input1}
                          autocomplete="off"
                          id={1}
                          onPaste={handlePaste}
                          onCopy={(e) => e.preventDefault()}
                        />
                      </div>

                      <div className="digit">
                        <input
                          type="number"
                          name="input2"
                          maxLength={1}
                          onChange={handleChange}
                          onKeyDown={handleKeyDown} // PRATISHRUTI ADD CODE HERE
                          onBlur={otpFieldValidationCheck}
                          value={formData.input2}
                          autocomplete="off"
                          id={2}
                          onPaste={handlePaste}
                          onCopy={(e) => e.preventDefault()}
                        />
                      </div>
                      <div className="digit">
                        <input
                          type="number"
                          name="input3"
                          maxLength={1}
                          onChange={handleChange}
                          onKeyDown={handleKeyDown} // PRATISHRUTI ADD CODE HERE
                          onBlur={otpFieldValidationCheck}
                          value={formData.input3}
                          autocomplete="off"
                          id={3}
                          onPaste={handlePaste}
                          onCopy={(e) => e.preventDefault()}
                        />
                      </div>
                      <div className="digit">
                        <input
                          type="number"
                          name="input4"
                          maxLength={1}
                          onChange={handleChange}
                          onKeyDown={handleKeyDown} // PRATISHRUTI ADD CODE HERE
                          onBlur={otpFieldValidationCheck}
                          value={formData.input4}
                          autocomplete="off"
                          id={4}
                          onPaste={handlePaste}
                          onCopy={(e) => e.preventDefault()}
                        />
                      </div>
                      <div className="digit">
                        <input
                          type="number"
                          name="input5"
                          maxLength={1}
                          onChange={handleChange}
                          onKeyDown={handleKeyDown} // PRATISHRUTI ADD CODE HERE
                          onBlur={otpFieldValidationCheck}
                          value={formData.input5}
                          autocomplete="off"
                          id={5}
                          onPaste={handlePaste}
                          onCopy={(e) => e.preventDefault()}
                        />
                      </div>
                      <div className="digit">
                        <input
                          type="number"
                          name="input6"
                          maxLength={1}
                          onChange={handleChange}
                          onKeyDown={handleKeyDown} // PRATISHRUTI ADD CODE HERE
                          onBlur={otpFieldValidationCheck}
                          value={formData.input6}
                          autocomplete="off"
                          id={6}
                          onPaste={handlePaste}
                          onCopy={(e) => e.preventDefault()}
                        />
                      </div>
                    </div>
                    {errors.otp && (
                      <span className="error-message">{errors.otp}</span>
                    )}
                  </div>
                </div>

                <div className="form-group mb-0">
                  <div className="pwd-group">
                    <label className="mb-1">
                      Password <span className="imp-field">*</span>
                    </label>
                    &nbsp;
                    <div className="password-info-icon-container">
                      <FaInfoCircle className="info-icon" />
                      <div className="tooltip">
                        {constantMessages?.passwordRegex}
                      </div>
                    </div>
                    <div className="inner-group">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="currentColor"
                        className="bi bi-eye-slash"
                        viewBox="0 0 16 16"
                        onClick={() => showPassword("password")}
                      >
                        <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7 7 0 0 0-2.79.588l.77.771A6 6 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755q-.247.248-.517.486z" />
                        <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829" />
                        <path d="M3.35 5.47q-.27.24-.518.487A13 13 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7 7 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12z" />
                      </svg>
                      <input
                        type="password"
                        placeholder="Enter Password"
                        name="password"
                        id="password"
                        onChange={handleChange}
                        onBlur={passwordFieldValidationCheck}
                        value={formData.password}
                      />
                    </div>
                    {errors.password && (
                      <span className="error-message">{errors.password}</span>
                    )}
                  </div>
                </div>

                <div className="form-group">
                  <div className="cpwd-group">
                    <label className="mb-1">
                      Confirm Password <span className="imp-field">*</span>
                    </label>
                    <div className="inner-group">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="currentColor"
                        className="bi bi-eye-slash"
                        viewBox="0 0 16 16"
                        onClick={() => showPassword("confirmPassword")}
                      >
                        <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7 7 0 0 0-2.79.588l.77.771A6 6 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755q-.247.248-.517.486z" />
                        <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829" />
                        <path d="M3.35 5.47q-.27.24-.518.487A13 13 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7 7 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12z" />
                      </svg>
                      <input
                        type="password"
                        autocomplete="off"
                        placeholder="Enter Confirm Password"
                        name="confirmPassword"
                        id="confirmPassword"
                        onChange={handleChange}
                        onBlur={confirmPasswordFieldValidationCheck}
                        value={formData.confirmPassword}
                        onPaste={(e) => {
                          e.preventDefault();
                          return false;
                        }}
                        onCopy={(e) => {
                          e.preventDefault();
                          return false;
                        }}
                      />
                    </div>
                    {errors.confirmPassword && (
                      <span className="error-message">
                        {errors.confirmPassword}
                      </span>
                    )}
                  </div>
                </div>

                {!authData.loading ? (
                  <button className="signin-btn1" type="submit">
                    {" "}
                    Verify OTP
                  </button>
                ) : (
                  <button disabled={true} className="signin-btn1" type="button">
                    <Spinner
                      as="span"
                      animation="grow"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />{" "}
                    Processing...
                  </button>
                )}

                <div className="back-resend back-arrow">
                  <Link to="/login-by-password">
                    <div className="back">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="#0b77e8"
                        className="bi bi-arrow-left"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"
                        />
                      </svg>
                      <span
                        onClick={() => {
                          if (!authData.loading) {
                            dispatch(updateIsSuccess(true));
                          }
                        }}
                      >
                        Back to Sign In
                      </span>
                    </div>
                  </Link>

                  {authData.isTimerOn ? (
                    <span>
                      {constantMessages.otpCountDownMessage}
                      <Timer
                        minutes={
                          authData.isOtpProcessed && !authData.isSuccess
                            ? process.env.REACT_APP_OTP_RESEND_TIME
                            : process.env.REACT_APP_CHECK_OTP_VALIDATION_TIME
                        }
                      />
                    </span>
                  ) : (
                    <div className="resend">
                      <Link to="" onClick={resendOtpAction}>
                        Resend OTP
                      </Link>
                    </div>
                  )}
                </div>
              </form>
            </div>
          </div>
          <LoginImage />
        </div>
      </div>
    </section>
  );
};

export default SetPassword;
